import { send } from '../../../../../../src/network';
import { type CustomerFavoriteProducts } from '../../../../../../src/types/CustomerFavoriteProducts';

interface PostFavoriteProductPostBody {
  product_id: number;
}

interface PostFavoriteProductParams {
  customerId: number;
  body: PostFavoriteProductPostBody;
}

export const postFavoriteProductPath = ({
  customerId,
}: Pick<PostFavoriteProductParams, 'customerId'>) =>
  `/api/v2/customers/${customerId}/favorite_products/`;

export async function postFavoriteProducts({
  customerId,
  body,
}: PostFavoriteProductParams) {
  return await send<CustomerFavoriteProducts>({
    path: postFavoriteProductPath({ customerId }),
    method: 'POST',
    body,
  });
}
